import React from 'react';
import AtlasV2ComparableSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2ComparableSplineChart';

/**
 * Product with Organic Traffic
 */
const AtlasV2PaidTrafficAdSpendProductSplineChart = () => {
  return (
    <AtlasV2ComparableSplineChart
      indexName="traffic"
      fieldName="stacklineSku"
      title="Products with Paid Traffic"
      requestBuilder={(builder) => builder.addConditionRangeFilter('adClicks', 1)}
    />
  );
};

export default AtlasV2PaidTrafficAdSpendProductSplineChart;
